"use client";

import type { SidebarNavGroup } from "@/types/sidebar";
import { NavigationSection } from "./navigation-section";
interface NavigationMenuProps {
  groups: SidebarNavGroup[];
  onClose?: () => void;
  forceExpanded?: boolean;
  showToggle?: boolean;
}
export function NavigationMenu({
  groups,
  onClose,
  forceExpanded,
  showToggle
}: NavigationMenuProps) {
  return groups.map((group, index) => <NavigationSection key={group.title ?? index} group={group} onClose={onClose} forceExpanded={forceExpanded} prependToggle={showToggle && index === 0} />);
}